var path = 'areas/master/getting-started/views/orbicular.html';
var html = "<div class=\"co-circle co-full\"> <div class=co-fill></div> </div> <div class=\"co-circle co-half\"> <div class=co-fill></div> <div class=\"co-fill co-fix\"></div> </div> <div class=co-content> <div> <div> <div ng-transclude></div> </div> </div> </div> <div class=complete><i class=\"fa fa-check\" aria-hidden=true></i></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./app/areas/master/getting-started/views/orbicular.html
// module id = 6381081614702651
// module chunks = 1